import type { BilingualText } from '../../../types/eqms-forms.types';
export const selectClass = 'h-9 w-full rounded-md border border-input bg-background px-3 text-sm';
export function bilingual(value: BilingualText | undefined, language: string): string {
  return value?.[language === 'fr' ? 'fr' : 'en'] || value?.en || value?.fr || '';
}
